import React, { FC } from "react";
import Image from "next/image";
import { renderCountryImage, renderShopIcon } from "@/utils/iconRenderer";
import { Country, Shop } from "@/enums";

type TProps = {
  shop: string;
  country: Country;
};

const ShopWithCountry: FC<TProps> = ({ shop, country }) => {
  return (
    <div className="relative flex h-11 w-11 items-center justify-center rounded-full bg-[#f9f9f9] p-2">
      <Image
        src={renderShopIcon[shop] || renderShopIcon[Shop.UNIVERSAL]}
        width={100}
        height={100}
        alt="shop-image"
      />

      <div className="absolute bottom-0 right-0 flex h-4 w-4 items-center justify-center">
        <Image
          src={renderCountryImage[country]}
          width={100}
          height={100}
          alt="country-image"
        />
      </div>
    </div>
  );
};

export { ShopWithCountry };
